"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uncrunch = void 0;
var JSON_1 = require("../JSON");
function uncrunch(values) {
  var expanded = [];
  var lookup = function lookup(i) {
    return expanded[i];
  };
  expanded.length = values.length; // Hint at array length for perf boost.
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    expanded[i] = (0, JSON_1.isContainer)(value) ? (0, JSON_1.map)(value, lookup) : value;
  }
  return expanded[expanded.length - 1];
}
exports.uncrunch = uncrunch;